import { useTranslation } from 'react-i18next';
import { supportedLngs } from 'vl-common/src/lib/i18n';

export default function LocaleSwitcher() {
  const { i18n } = useTranslation('common');

  const handleChange = async (lng: string) => {
    await i18n.reloadResources([lng]);
    await i18n.changeLanguage(lng);
  };

  return (
    <div data-testid="locale-switcher-select">
      <select value={i18n.language || 'en'} onChange={(e) => handleChange(e.target.value)}>
        {Object.entries(supportedLngs).map(([code, name]) => (
          <option value={code} key={code}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
}
